
import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UrlHistoryService {
  private router = inject(Router);

  private readonly ROUTE_STORAGE_KEY = 'routes';

  /** Start tracking routes */
  
public startTracking(): void {
  this.router.events.pipe(
    filter((event): event is NavigationStart => event instanceof NavigationStart)
  ).subscribe(event => {
    this.addRoute(event.url);
  });
}


  /** Add a route to session storage */
  private addRoute(route: string): void {
    if (!route) return; // Prevent null/empty
    const routes = this.getRoutes();
    // Avoid consecutive duplicates
    if (routes.length && routes[routes.length - 1] === route) return;

    routes.push(route);
    if (routes.length > 10) {
      routes.shift();
    }
    sessionStorage.setItem(this.ROUTE_STORAGE_KEY, JSON.stringify(routes));
  }

  /** Get all stored routes */
  private getRoutes(): string[] {
    const routes = sessionStorage.getItem(this.ROUTE_STORAGE_KEY);
    return routes ? JSON.parse(routes) : [];
  }

  /** Public method to get last routes */
  public getLastRoutes(): string[] {
    return this.getRoutes();
  }
}

